// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","logo":"logo_logo__lo2YB","logo__auth":"logo_logo__auth__viy9D","logo__main":"logo_logo__main__OlAq2"};